import axiosInstance from "./api_helper";

const categoryService = { 
    list: async (query, size = 10) => {
        return axiosInstance.get(`/api/categories/list`, {
            params: {
                query,
                size
            }
        });
    },
    create: async (payload) => {
        return await axiosInstance.post('/api/categories', payload);
    },
    update: async (payload) => {
        return axiosInstance.put(`/api/categories/${payload.id}`, JSON.stringify(payload));
    },
    delete: async (id) => {
        return axiosInstance.delete(`/api/categories/${id}`);
    },
    activate: async (id) => {
        return axiosInstance.put(`/api/categories/activer/${id}`);
    },
};

export default categoryService;
